if($('.form-add').length) {
    $('.form-add').click(function(){
        $(this).parent().append('<div class="form-field"><input type="email" placeholder="Insert e-mail" /></div>');
    });
}